module.exports = __webpack_public_path__ + "img/guifu.c475cc01.png";